import 'bootstrap';

import { initPage } from './init/doc-ready.js';
import './forms';

$(function () {
    initPage();
});
